import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { ASSETS_BASE_URL } from '../../config/config';
import './BackgroundImg.css';

const getAssetUrl = (path) =>
  path?.startsWith('http') ? path : `${process.env.REACT_APP_ASSETS_BASE_URL}/${path}`;

const BackgroundImg = (props) => {
  const opacity = props.opacity != null ? props.opacity : 1;

  // Video / image modes must never fall through to the leftover colour field
  if (props.video) {
    if (!props.path) return null;
    return (
      <div id="bg" style={{ opacity }} className="bg-wrapper">
        <video
          className="bg bg-video"
          autoPlay
          loop
          muted
          playsInline
          src={getAssetUrl(props.path)}
        />
      </div>
    );
  }

  if (props.img) {
    if (!props.path) return null;
    return (
      <div id="bg" style={{ opacity }} className="bg-wrapper">
        <LazyLoadImage
          className="bg bg-img"
          alt="Background Image"
          src={getAssetUrl(props.path)}
          effect="blur"
        />
      </div>
    );
  }

  if (props.colour == null || props.colour === '') return null;

  return (
    <div
      id="bg"
      style={{
        backgroundColor: props.colour,
        opacity,
      }}
      className="bg"
    />
  );
};

export default React.memo(BackgroundImg);
